import EFPicture from '@elem/compCommon/EFPicture';
import { useEffect, useState } from 'react';
import { getShopifyProductList } from 'lowcode/apis/getShopifyProductList';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import SectionPro from '../components/SectionPro';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import FSwiper from '../components/FSwiper';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import gtm from '@/utils/gtm';

const OccasionChoose: React.FC = () => {
    const { locale } = getLocal();

    const [tabItems, setTabItems] = useState([
        {
            title: '快適車中泊セット',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745036089647/%E5%BF%AB%E9%81%A9%E8%BB%8A%E4%B8%AD%E6%B3%8A%E3%82%BB%E3%83%83%E3%83%88%20(1).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745218376499/%E5%BF%AB%E9%81%A9%E8%BB%8A%E4%B8%AD%E6%B3%8A%E3%82%BB%E3%83%83%E3%83%88%20(3)%20(1).jpg',
            products: [
                {
                    img: '',
                    label: '2kWh ベーシックセット',
                    title: '',
                    desc: '2kWh容量 | 2kW出力 | フル充電まで2.6時間 大容量 & 移動時間で充電',
                    price: 0,
                    compareAtPrice: '',
                    variantId: '44331115479201',
                    tag: '',
                },
                {
                    img: '',
                    label: 'エアコン快適空間セット',
                    title: '',
                    desc: '冷暖房 + 除湿機能付き & 簡単設置',
                    price: 0,
                    compareAtPrice: '',
                    variantId: '51927583097199',
                    tag: '',
                },
                {
                    img: '',
                    label: '食事を楽しむ冷蔵庫セット',
                    title: '',
                    desc: '45L | デュアルゾーン| 庫内分割で同時に冷蔵・冷凍',
                    price: 0,
                    compareAtPrice: '',
                    variantId: '52017091215727',
                    tag: '',
                    // buttonText: '6月上旬発売予定',
                },
            ],
        },
        {
            title: '車中泊避難セット',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745206309763/%E8%BB%8A%E4%B8%AD%E6%B3%8A%E9%81%BF%E9%9B%A3%E3%82%BB%E3%83%83%E3%83%88%20(1).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745218417309/%E8%BB%8A%E4%B8%AD%E6%B3%8A%E9%81%BF%E9%9B%A3%E3%82%BB%E3%83%83%E3%83%88%20(2)%20(1).jpg',
            products: [
                {
                    img: '',
                    label: '安心の車中泊セット\n（晴れの日用）',
                    title: '',
                    desc: (
                        <div className="nowrap">
                            2kWh容量 | 2kW出力 | フル充電まで
                            <br />
                            2.9時間停電時も安心のバックアップ
                        </div>
                    ),
                    price: 0,
                    compareAtPrice: '',
                    variantId: '51877845664111',
                    tag: '',
                },
                {
                    img: '',
                    label: 'お手軽車中泊避難セット\n（晴れの日用）',
                    title: '',
                    desc: '持ち運び・収納ラクラク | 簡単セットアップ',
                    price: 0,
                    compareAtPrice: '',
                    variantId: '43021123387553',
                    tag: '',
                },
                {
                    img: '',
                    label: '悪天候でも安心セット',
                    title: '',
                    desc: '4kWh容量 | 縦積み省スペース設計',
                    price: 0,
                    compareAtPrice: '',
                    variantId: '43021111689377',
                    tag: '',
                },
            ],
        },
        {
            title: '防災・節電セット',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745206309944/%E9%98%B2%E7%81%BD%E3%83%BB%E7%AF%80%E9%9B%BB%E3%82%BB%E3%83%83%E3%83%88%20(1).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745218433071/%E9%98%B2%E7%81%BD%E3%83%BB%E7%AF%80%E9%9B%BB%E3%82%BB%E3%83%83%E3%83%88%20(2)%20(1).jpg',
            products: [
                {
                    img: '',
                    label: '防災 & 節電セット\n（晴れの日用）',
                    title: '',
                    desc: '2kWh容量 | 2kW出力 | 自宅でお手軽発電',
                    price: 0,
                    compareAtPrice: '',
                    variantId: '43021137805473',
                    tag: '',
                },
                {
                    img: '',
                    label: '悪天候でも安心セット',
                    title: '',
                    desc: '4kWh容量 | 縦積み省スペース設計',
                    price: 0,
                    compareAtPrice: '',
                    variantId: '43021111689377',
                    tag: '',
                },
                {
                    img: '',
                    label: '家族で安心 大容量セット',
                    title: '',
                    desc: '4kWh容量 | 縦積み省スペース設計 | \nAC同時充電可能',
                    price: 0,
                    compareAtPrice: '',
                    variantId: '43150734098593',
                    tag: '',
                },
            ],
        },
    ]);

    const [activeItem, setActiveItem] = useState(tabItems[0]);

    let variantIds: string[] = [];

    for (const item of tabItems) {
        variantIds = [...variantIds, ...item.products.map((item) => item.variantId)];
    }

    const initProductList = async () => {
        const res = await getShopifyProductList(locale, variantIds);
        // 混入img productTitle price等参数
        const newList = tabItems.map((item) => {
            return {
                ...item,
                products: item.products.map((product) => {
                    const target = res.find((resItem: any) => resItem.variantId === product.variantId);
                    return {
                        ...product,
                        img: target?.variantImg,
                        price: target?.price,
                        title: target?.productTitle,
                        compareAtPrice: target?.compareAtPrice,
                    };
                }),
            };
        });
        setTabItems(newList);
        setActiveItem(newList[0]);
    };

    function handleBuy(item: (typeof tabItems)[0]['products'][0]) {
        if (item.buttonText) return;

        // 打开购物车
        editorEventsBus.emit('ShopifyCart-add', {
            ...item,
            imageUrl: item.img,
        });
        console.log('---', item);
        // 埋点
        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: item.title,
            position: `Occasion Choose Page_${item?.title}`,
            __btn_id1: styles.OccasionChoose,
            __btn_id2: item.title,
        });
    }

    useEffect(() => {
        initProductList();
    }, []);

    return (
        <div
            className={`${styles.OccasionChoose} GtmModuleData-section`}
            data-section-id="occasion-choose"
            data-section-title="シーンに合わせて選べるお得なセット"
        >
            <SectionPro title="シーンに合わせて選べるお得なセット">
                <div className="tab-items">
                    {tabItems.map((item) => {
                        return (
                            <div
                                className={'tab-item ' + (activeItem === item ? 'active' : '') + ' GtmModuleData-btn-text'}
                                key={item.title}
                                onClick={() => {
                                    setActiveItem(item);
                                    gtm.push({
                                        ___btn_id1: styles.OccasionChoose,
                                        __btn_id2: item.title,
                                    });
                                }}
                            >
                                {item.title}
                            </div>
                        );
                    })}
                </div>
                <div className="img-wrapper">
                    <EFPicture src={activeItem.pc} srcPad={activeItem.pad} />
                </div>
                <div className="item-wrapper">
                    <FSwiper>
                        {activeItem.products.map((product, index) => {
                            return (
                                <div className="item" key={index}>
                                    <div className="product-img-wrapper">
                                        <EFPicture src={product.img} />
                                        {product.tag && <div className="tag">{product.tag}</div>}
                                    </div>
                                    <div className="box">
                                        <div className="top">
                                            <div className="label">{product.label}</div>
                                            <div className="title">{product.title}</div>
                                            <div className="desc">{product.desc}</div>
                                        </div>
                                        <div className="bottom">
                                            {!product.buttonText && (
                                                <>
                                                    <div className="price">限定価格{FormatMoneyLocal(product.price || 0, locale)}（税込）</div>
                                                    {product.price !== product.compareAtPrice && (
                                                        <div className="compare-price">
                                                            通常価格{FormatMoneyLocal(product.compareAtPrice || 0, locale)}（税込）
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                            <div
                                                className={'button ' + (product.buttonText ? 'disabled' : '') + ' GtmModuleData-btn-text'}
                                                onClick={() => handleBuy(product)}
                                            >
                                                {product.buttonText ? product.buttonText : 'カートに追加'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </FSwiper>
                </div>
                {/* <div className="choose-footer">
                    *製品の一括発送をご希望された場合、セット製品のすべてが記載された時期に発送されます。
                    個別発送をご希望された場合、対象製品以外は在庫状況に応じて先行して発送されます。
                </div> */}
            </SectionPro>
        </div>
    );
};

export default OccasionChoose;
